import "./styles.scss";

const DotFlashing = ({ className = "" }) => {
  return (
    <div className={`loading-block ${className}`}>
      <div className="dot-flashing" />
    </div>
  );
};

export default DotFlashing;
